import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=230d45a4"
import script from "./app-footer.vue?vue&type=script&lang=ts"
export * from "./app-footer.vue?vue&type=script&lang=ts"
import style0 from "./app-footer.vue?vue&type=style&index=0&id=230d45a4&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230d45a4')) {
      api.createRecord('230d45a4', component.options)
    } else {
      api.reload('230d45a4', component.options)
    }
    module.hot.accept("./app-footer.vue?vue&type=template&id=230d45a4", function () {
      api.rerender('230d45a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layout/app-footer.vue"
export default component.exports